import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Primitives";
import { errText, http } from "@/lib/site";

export const AdminLogin = ({ onAuthed }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("vectis_admin_token", data.token);
      onAuthed(data.token);
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid place-items-center px-5 bg-[var(--paper)]" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white border border-slate-200 p-8 shadow-xl">
        <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
        <h1 className="mt-8 font-display text-3xl font-semibold">Lead dashboard</h1>
        <p className="mt-1 text-sm text-slate-600">Sign in to view incoming requests.</p>
        <Input className="mt-6 h-12 rounded-xl" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
        <Input className="mt-3 h-12 rounded-xl" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
        {error && <p className="mt-3 text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-6 w-full inline-flex justify-center items-center gap-2 rounded-full bg-[var(--ink)] text-white py-3.5 font-semibold hover:bg-[var(--cobalt)] transition-colors disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
